import { render, staticRenderFns } from "./OrderShippingEditor.vue?vue&type=template&id=192b9c2f&scoped=true"
import script from "./OrderShippingEditor.vue?vue&type=script&lang=js"
export * from "./OrderShippingEditor.vue?vue&type=script&lang=js"
import style0 from "./OrderShippingEditor.vue?vue&type=style&index=0&id=192b9c2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192b9c2f",
  null
  
)

export default component.exports